import React from 'react';

export const BrandLogo = ({ size = 36, withText = false, className = '' }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div
        className="relative rounded-full overflow-hidden bg-black ring-1 ring-[#00E676]/40 shrink-0"
        style={{ width: size, height: size }}
      >
        <img
          src="https://customer-assets.emergentagent.com/job_social-boost-353/artifacts/evt7j1yg_%2B54%209%203447%2043-8147%2020260621_160302.jpg"
          alt="Agency Market"
          className="w-full h-full object-cover"
        />
      </div>
      {withText && (
        <div className="flex flex-col leading-none">
          <span className="font-bold text-base tracking-tight">Agency Market</span>
          <span className="text-[10px] text-[#00E676] font-semibold tracking-widest mt-0.5">.AR</span>
        </div>
      )}
    </div>
  );
};
